import { render, staticRenderFns } from "./schedules.vue?vue&type=template&id=10e8a9fd&scoped=true&"
import script from "./schedules.ts?vue&type=script&lang=ts&"
export * from "./schedules.ts?vue&type=script&lang=ts&"
import style0 from "./schedules.scss?vue&type=style&index=0&id=10e8a9fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e8a9fd",
  null
  
)

export default component.exports